import React from "react";
import moment from "moment";

const milestone = props => {
  let milestoneIcon = "unavailable";
  let milestoneColor = "secondary";
  let milestoneComplete = false;
  let milestoneCompletedDate = "--/--/--";

  switch (props.milestone.milestoneStatus) {
    case 3: // In progress
      milestoneIcon = "in_progress";
      milestoneColor = "warning";
      milestoneComplete = false;
      milestoneCompletedDate = moment(props.milestone.completedDate).format(
        "DD/MM/YYYY"
      );
      break;
    case 4: // Completed
    case 5: // Completed without running
      milestoneIcon = "checked";
      milestoneColor = "success";
      milestoneComplete = true;
      if (props.milestone.completedDate > "1753-01-01 00:00:00") {
        milestoneCompletedDate = moment(props.milestone.completedDate).format(
          "DD/MM/YYYY"
        );
      }
      break;
    default:
      break;
  }

  return (
    <mosaic-status-card
      // key={milestoneCounter}
      color={milestoneColor}
      icon={milestoneIcon}
      size="lg"
      disabled
      complete={milestoneComplete}
      first={props.isFirst}
      last={props.isLast}
    >
      <mosaic-status-card-title>
        {props.milestone.milestoneName}
      </mosaic-status-card-title>
      <div className="font-weight-light">{milestoneCompletedDate}</div>
    </mosaic-status-card>
  );
};

export default milestone;
